import './index.less'
import { getProductBundledInfo, } from '@utils/api.js'
import { formatMoney } from '@shopify/theme-currency'
import { gaProductDetailDataLayer, } from "@utils/index.js"

class ProductBundledSale {
  constructor() {
    this.DOM = document.querySelector('#app-bundled-sale')
    const { productTitle, variantId, variantTitle, } = this.DOM.dataset

    this.productTitle = productTitle
    this.variantId = variantId
    this.variantTitle = variantTitle

    // 分页
    this.pageNum = 1
    this.pageSize = 5
    this.total = 0

    // 接口请求中
    this.loading = false

    this.init()

    // 新 main-product 触发variant变化 - 改变当前变体
    if (document.querySelector('variant-fields')) {
      document.addEventListener('variantChangeEvent', e => {
        const currentVariant = e.detail.variant
        if (currentVariant) {
          this.variantId = currentVariant.id
          this.variantTitle = currentVariant.title

          // 重置 pageNum
          this.pageNum = 1
          setTimeout(() => this.init(), 200)
        }
      })
    }
  }

  async init() {
    try {
      this.loading = true
      const { data } = await getProductBundledInfo({ skuId: this.variantId, page: this.pageNum, limit: this.pageSize, })
      if (data?.total > 0) {
        const { title, bundleGoodsList, total, } = data
        this.total = total

        this.DOM.innerHTML = this.renderDOM(title)
        this.DOM.parentElement.style.display = 'block'

        this.ulDOM = this.DOM.querySelector('ul')
        const bundleList = this.renderBundleList(bundleGoodsList)
        this.ulDOM.insertAdjacentHTML('beforeend', bundleList)

        // 初始化 label 交互事件
        this.initLabelEvent()

        // 监听滚动事件
        this.watchScroll = this.watchScroll.bind(this)
        this.ulDOM.removeEventListener('scroll', this.watchScroll)
        this.ulDOM.addEventListener('scroll', this.watchScroll)
      } else {
        // 清空DOM
        this.DOM.innerHTML = ''
        this.DOM.parentElement.style.display = 'none'
      }
    } catch(err) {
      // 清空DOM
      this.DOM.innerHTML = ''
      this.DOM.parentElement.style.display = 'none'
    } finally {
      this.loading = false
    }
  }

  watchScroll() {
    if (this.isScrollAtBottom() && !this.loading) {
      if (Math.ceil(this.total / this.pageSize) <= this.pageNum) return

      // 加载数据
      this.loadData()
    }
  }

  async loadData() {
    try {
      this.pageNum++
      this.loading = true
      const { data: { bundleGoodsList, } } = await getProductBundledInfo({
        skuId: this.variantId,
        page: this.pageNum,
        limit: this.pageSize,
      })
      this.ulDOM.insertAdjacentHTML('beforeend', this.renderBundleList(bundleGoodsList))

      // 初始化 label 交互事件
      this.initLabelEvent()
    } catch(err) {
      console.log(err)
    } finally {
      this.loading = false
    }
  }

  // 初始化 label 交互事件
  initLabelEvent() {
    const _this = this
    this.ulDOM.querySelectorAll('label').forEach(item => {
      const checkbox = item.querySelector('input[type="checkbox"]')
      
      // 处理 checkbox change 事件
      function handleChangeBox(e) {
        e.preventDefault()
        const inputWrapPC = item.querySelector('[data-quantity-input-wrap-pc]')
        const inputWrapMB = item.querySelector('[data-quantity-input-wrap-mb]')
        if(e.target.checked) {
          inputWrapPC.classList.add('flex')
          inputWrapMB.classList.remove('hidden')
          inputWrapMB.classList.add('flex')
          inputWrapMB.classList.remove('hidden')
        } else {
          inputWrapPC.classList.add('hidden')
          inputWrapPC.classList.remove('flex')
          inputWrapMB.classList.add('hidden')
          inputWrapMB.classList.remove('flex')

          item.querySelectorAll('[data-quantity-input]').forEach(it => it.value = 1)
        }

        // 数据埋码
        gaProductDetailDataLayer({
          "product_spu_name": _this.productTitle, //识别页面产品spu标题名称text
          "module": "Product Selection",//固定模块命名Product Selection
          "options": _this.variantTitle, //主体产品sku文本text
          "add_on": e.target.getAttribute("title"), //捆绑产品sku文本text
          "position": e.target.checked ? "check" : "remove", // 勾选该产品，则为check，移除该产品则为remove
          "options_price": $('.product-info-container .product--price')?.text(), //主体产品现价（黑色字体价格），当地货币
          "add_on_price": e.target.getAttribute("price"), //捆绑产品现价（黑色字体价格），当地货币
        })
      }
      checkbox.removeEventListener('change', handleChangeBox)
      // 避免重复注册 click 事件
      if (!checkbox.dataset.hasEvent) {
        checkbox.addEventListener('change', handleChangeBox)
        checkbox.dataset.hasEvent = true
      }

      // 初始化 quantity-input 交互事件
      this.initQuantityEvent(item)
    })
  }

  // 初始化 quantity-input 交互事件
  initQuantityEvent(item) {
    const minusBtns = item.querySelectorAll('[data-button-minus]')
    const quantityInputs = item.querySelectorAll('[data-quantity-input]')
    const plusBtns = item.querySelectorAll('[data-button-plus]')

    function handleMinus(e) {
      e.preventDefault()

      const target = e.target.tagName.toLowerCase() !== 'button' ? e.target.closest('button') : e.target

      quantityInputs.forEach(it => {
        plusBtns.forEach(m => m.removeAttribute('disabled'))
        it.value = it.value * 1 > 1 ? it.value * 1 - 1 : 1

        if (it.value == 1) {
          target.setAttribute('disabled', 'disabled')
        }
      })

      // 数据埋码
      gaProductDetailDataLayer({
        "product_spu_name": $('.product__title')?.text()?.trim(), //识别页面产品spu标题名称text
        "module": "Product Selection",//固定模块命名Product Selection
        "options": document.querySelector('variant-fields')?.currentVariant?.title, //主体产品sku文本text
        "add_on": target.dataset.skuTitle, //捆绑产品sku文本text
        "action": "minus", // 点击减号固定命名：minus
        "options_price": $('.product-info-container .product--price')?.text(), //主体产品现价（黑色字体价格），当地货币
        "add_on_price": target.dataset.skuPrice, //捆绑产品现价（黑色字体价格），当地货币
      })
    }

    function handlePlus(e) {
      e.preventDefault()

      const target = e.target.tagName.toLowerCase() !== 'button' ? e.target.closest('button') : e.target

      quantityInputs.forEach(it => {
        minusBtns.forEach(m => m.removeAttribute('disabled'))
        it.value = it.value * 1 < Number(it.dataset.max) ? it.value * 1 + 1 : Number(it.dataset.max)

        if (it.value == Number(it.dataset.max)) {
          target.setAttribute('disabled', 'disabled')
        }
      })

      // 数据埋码
      gaProductDetailDataLayer({
        "product_spu_name": $('.product__title')?.text()?.trim(), //识别页面产品spu标题名称text
        "module": "Product Selection",//固定模块命名Product Selection
        "options": document.querySelector('variant-fields')?.currentVariant?.title, //主体产品sku文本text
        "add_on": target.dataset.skuTitle, //捆绑产品sku文本text
        "action": "plus", // 点击加号固定命名：plus
        "options_price": $('.product-info-container .product--price')?.text(), //主体产品现价（黑色字体价格），当地货币
        "add_on_price": target.dataset.skuPrice, //捆绑产品现价（黑色字体价格），当地货币
      })
    }

    minusBtns.forEach(it => {
      it.removeEventListener('click', handleMinus)
      // 避免重复注册 click 事件
      if (!it.dataset.hasEvent) {
        it.addEventListener('click', handleMinus)
        it.dataset.hasEvent = true
      }
    })

    plusBtns.forEach(it => {
      it.removeEventListener('click', handlePlus)
      // 避免重复注册 click 事件
      if (!it.dataset.hasEvent) {
        it.addEventListener('click', handlePlus)
        it.dataset.hasEvent = true
      }
    })
  }

  renderDOM(title) {
    return `
      <div
        class="
          text-#1A1A1A text-44 leading-56 mb-30
          lg:j-text-18 lg:j-leading-24 lg:j-mb-12
          xl:a-text-18 xl:a-leading-24 xl:a-mb-12
        "
        data-app-bundled-sale-title
      >${title}</div>
      <ul
        class="
          flex flex-col max-h-780 gap-y-24 pr-18 overflow-y-auto
          lg:j-max-h-298 lg:j-gap-y-16 lg:j-pr-10
          xl:a-max-h-298 xl:a-gap-y-16 xl:a-pr-10
        "
      ></ul>
    `
  }
  renderBundleList(list) {
    let html = ''
    list.forEach(({ skuId, title, price, originPrice, positioningDesc, positioningDescColor, image, stock, }, index) => {
      const formatPrice = formatMoney(price * 100, window?.pageInfo?.currency?.money_format)
      const quantityInputHTML = this.renderQuantityInput(stock, skuId, title, formatPrice)
      html += `
        <label for="add-on-${skuId + '--' + index}" class="flex shrink-0 items-start lg:items-center flex-row border-solid border-black/15 w-full px-20 py-24 gap-x-16 rounded-20 border-2 lg:j-max-w-500 lg:j-min-h-100 lg:j-border-1 lg:j-rounded-8 xl:a-max-w-500 lg:j-gap-x-10 lg:j-pl-12 lg:j-pr-16 lg:j-py-8 xl:a-min-h-100 xl:a-border-1 xl:a-rounded-8 xl:a-gap-x-10 xl:a-pl-12 xl:a-pr-16 xl:a-py-8">
          <div class="flex items-center gap-x-16 lg:j-gap-x-10 xl:a-gap-x-10">
            <input type="checkbox" id="add-on-${skuId + '--' + index}" title="${title}" price="${formatPrice}" class="w-32 h-32 lg:j-w-16 lg:j-h-16 xl:a-w-16 xl:a-h-16">
            <img class="w-108 h-108 lg:j-w-64 lg:j-h-64 xl:a-w-64 xl:a-h-64" src="${image}" alt="" loading="lazy">
          </div>
          <div class="flex flex-col flex-1 lg:j-w-250 xl:a-w-250">
            <h4 class="text-#1A1A1A font-semibold lg:font-500 lg:font-medium text-30 leading-44 lg:j-text-14 lg:j-leading-22 xl:a-text-14 xl:a-leading-22">${title}</h4>
            <p class="flex flex-row lg:hidden mt-8">
              <em class="text-#1A1A1A font-semibold not-italic text-30 leading-44">${formatPrice}</em>
              ${originPrice > price
                ? `<span class="text-#999 font-400 text-28 leading-44 ml-20 line-through">${formatMoney(originPrice * 100, window?.pageInfo?.currency?.money_format)}</span>`
                : ''
              }
            </p>
            ${positioningDesc
              ? `<p class="text-#666 font-400 mt-16 lg:mt-0 text-24 leading-32 lg:j-text-12 lg:j-leading-18 xl:a-text-12 xl:a-leading-18" style="color:${positioningDescColor}">${positioningDesc}</p>`
              : ''
            }
            <div class="w-full hidden lg:hidden justify-end mt-16 lg:j-mt-1 xl:a-mt-1" data-quantity-input-wrap-mb>
              ${quantityInputHTML}
            </div>
          </div>
          <div class="hidden lg:flex flex-1 flex-col items-end lg:j-gap-y-4 xl:a-gap-y-4">
            <em class="text-#1A1A1A font-500 not-italic lg:j-text-18 lg:j-leading-24 xl:a-text-18 xl:a-leading-24">${formatMoney(price * 100, window?.pageInfo?.currency?.money_format)}</em>
            ${originPrice > price
              ? `<span class="text-#999 font-500 line-through lg:j-text-14 xl:a-text-14">${formatMoney(originPrice * 100, window?.pageInfo?.currency?.money_format)}</span>`
              : ''
            }

            <div class="mt-16 lg:j-mt-1 xl:a-mt-1 hidden" data-quantity-input-wrap-pc>
              ${quantityInputHTML}
            </div>
          </div>
        </label>
      `
    })

    return html
  }
  // 检查是否滚动到底部
  isScrollAtBottom() {
    return this.ulDOM.scrollHeight - this.ulDOM.scrollTop <= this.ulDOM.clientHeight + 50;
  }

  // 渲染 quantity-input
  renderQuantityInput(stock, skuId, title, price) {
    return `
      <div class="flex border-solid border-#EEE w-205 h-64 border-1 rounded-6 lg:j-w-102 lg:j-h-32 lg:j-border-1 lg:j-rounded-4 xl:a-w-102 xl:a-h-32 xl:a-border-1 xl:a-rounded-4">
        <button
          class="appearance-none bg-#F5F5F5 flex-center h-full w-64 lg:j-w-32 xl:a-w-32 disabled:opacity-50 disabled:cursor-not-allowed"
          disabled
          data-button-minus
          data-sku-title="${title}"
          data-sku-price="${price}"
        >
          ${this.renderMinusSVG()}
        </button>
        <input
          class="flex-center w-77 h-full text-center font-500 lg:j-w-38 lg:j-text-18 xl:a-w-38 xl:a-text-18"
          type="number"
          value="1"
          readonly
          data-quantity-input
          data-max="${stock}"
          data-sku-id="${skuId}"
          data-sku-title="${title}"
          data-sku-price="${price}"
        />
        <button
          class="appearance-none bg-#F5F5F5 flex-center h-full w-64 lg:j-w-32 xl:a-w-32 disabled:opacity-50 disabled:cursor-not-allowed"
          data-button-plus
          data-sku-title="${title}"
          data-sku-price="${price}"
        >
          ${this.renderPlusSVG()}
        </button>
      </div>
    `
  }
  renderMinusSVG() {
    return `
      <svg class="text-#333 w-28 h-28 lg:j-w-14 lg:j-h-14 xl:a-w-14 xl:a-h-14" viewBox="0 0 56 56" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g transform="translate(-1053.000000, -594.000000)">
            <g transform="translate(1053.000000, 594.000000)">
              <rect x="0" y="0" width="56" height="56"></rect>
              <g transform="translate(7.000000, 26.000000)" fill="#333" fill-rule="nonzero">
                <path d="M2.24098777,4.36809816 L39.3054147,4.36809816 C39.7082889,4.36809816 40.0817869,4.27048703 40.4259086,4.07526476 C40.7700303,3.8800425 41.0428097,3.61567902 41.2442468,3.28217432 C41.445684,2.94866961 41.5464025,2.57856074 41.5464025,2.17184769 C41.5464025,1.78140316 41.445684,1.41942855 41.2442468,1.08592384 C41.0428097,0.752419143 40.7700303,0.48805566 40.4259086,0.292833396 C40.0817869,0.0976111321 39.7082889,0 39.3054147,0 L2.24098777,0 C1.83811357,0 1.46881221,0.0976111321 1.1330837,0.292833396 C0.7973552,0.48805566 0.524575789,0.752419143 0.314745474,1.08592384 C0.104915158,1.41942855 0,1.78140316 0,2.17184769 C0,2.57856074 0.104915158,2.94866961 0.314745474,3.28217432 C0.524575789,3.61567902 0.7973552,3.8800425 1.1330837,4.07526476 C1.46881221,4.27048703 1.83811357,4.36809816 2.24098777,4.36809816 Z" id="路径"></path>
              </g>
            </g>
          </g>
        </g>
      </svg>
    `
  }
  renderPlusSVG() {
    return `
      <svg class="text-#333 w-28 h-28 lg:j-w-14 lg:j-h-14 xl:a-w-14 xl:a-h-14" viewBox="0 0 56 56" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g transform="translate(-931.000000, -594.000000)">
            <g transform="translate(931.000000, 594.000000)">
              <rect x="0" y="0" width="56" height="56"></rect>
              <g transform="translate(7.000000, 7.000000)" fill="#333" fill-rule="nonzero">
                <path d="M0,20.7484663 C0,21.3688244 0.222420135,21.8969672 0.667260404,22.3328946 C1.11210067,22.768822 1.63667646,22.9867856 2.24098777,22.9867856 L18.5322135,22.9867856 L18.5322135,39.2586131 C18.5322135,39.8622049 18.750437,40.386156 19.1868841,40.8304666 C19.6233311,41.2747772 20.1521035,41.4969325 20.7732013,41.4969325 C21.394299,41.4969325 21.927268,41.2747772 22.3721083,40.8304666 C22.8169485,40.386156 23.0393687,39.8622049 23.0393687,39.2586131 L23.0393687,22.9867856 L39.3054147,22.9867856 C39.909726,22.9867856 40.4343018,22.768822 40.8791421,22.3328946 C41.3239824,21.8969672 41.5464025,21.3688244 41.5464025,20.7484663 C41.5464025,20.1281081 41.3239824,19.5957737 40.8791421,19.1514631 C40.4343018,18.7071525 39.909726,18.4849972 39.3054147,18.4849972 L23.0393687,18.4849972 L23.0393687,2.23831939 C23.0393687,1.63472764 22.8169485,1.11077648 22.3721083,0.666465886 C21.927268,0.222155295 21.394299,0 20.7732013,0 C20.1521035,0 19.6233311,0.222155295 19.1868841,0.666465886 C18.750437,1.11077648 18.5322135,1.63472764 18.5322135,2.23831939 L18.5322135,18.4849972 L2.24098777,18.4849972 C1.63667646,18.4849972 1.11210067,18.7071525 0.667260404,19.1514631 C0.222420135,19.5957737 0,20.1281081 0,20.7484663 Z" id="路径"></path>
              </g>
            </g>
          </g>
        </g>
      </svg>
    `
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // 捆绑销售
  new ProductBundledSale()
})
